
import React from 'react';
import { Service, LandingSection, AppSettings, PortfolioItem, KaosSettings } from './types';

export const INITIAL_SERVICES: Service[] = [
  {
    id: 'kaos-custom',
    title: 'Kaos Cotton Premium',
    description: 'Produksi kaos custom bahan tebal berkualitas (20S/24S) dengan harga kompetitif.',
    icon: 'Shirt',
    category: 'Apparel',
    features: ['Cotton Combed 20S/24S', 'Sablon Berkualitas', 'Bisa Custom Ukuran', 'Pengerjaan Cepat'],
    priceRange: 'Mulai 80rb'
  },
  {
    id: 'web-dev',
    title: 'BisaBikin Website',
    description: 'Solusi website profesional, responsif, dan SEO-friendly untuk bisnis Anda.',
    icon: 'Monitor',
    category: 'Software',
    features: ['Custom Design', 'Landing Page', 'E-Commerce', 'Company Profile'],
    priceRange: '500rb - 3Jt'
  },
  {
    id: 'app-dev',
    title: 'BisaBikin Aplikasi',
    description: 'Pengembangan aplikasi mobile Android & iOS dengan teknologi terkini.',
    icon: 'Smartphone',
    category: 'Software',
    features: ['Native Apps', 'Cross-Platform', 'UX Optimization', 'Real-time Sync'],
    priceRange: '1jt - 75jt'
  },
  {
    id: 'multimedia-interaktif',
    title: 'Multimedia Interaktif',
    description: 'Pembuatan game edukasi, simulasi, dan konten interaktif berbasis web/desktop.',
    icon: 'Gamepad',
    category: 'Media',
    features: [
      'Jenjang Kelas X, XI, XII',
      'Infografis Interaktif',
      'Quiz Interaktif',
      'Drill Knowledge'
    ],
    priceRange: 'Hubungi Kami'
  },
  {
    id: 'teacher-ai',
    title: 'Administrasi Guru (AI)',
    description: 'Khusus Guru & Profesional: Generate RPPM, TP, dan Laporan Kegiatan otomatis.',
    icon: 'FileText',
    category: 'Education',
    features: ['RPPM Generator', 'TP & Modul Ajar', 'Laporan Kegiatan', 'Dokumen Akademik'],
    priceRange: 'Hubungi Kami'
  },
  {
    id: 'media-ai',
    title: 'AI Media Generator',
    description: 'Foto produk, video pendek, face swap, studio foto digital dalam hitungan detik.',
    icon: 'Camera',
    category: 'Media',
    features: ['Product Photo AI', 'Face Swap', 'Virtual Try-On', 'Video Short AI'],
    priceRange: 'Hubungi Kami'
  },
];

export const INITIAL_KAOS_SETTINGS: KaosSettings = {
  basePrice20S: 85000,
  basePrice24S: 80000,
  minOrder: 5,
  tiers: [
    { id: 't1', label: 'Pesan 20 Pcs', price: 110000 },
    { id: 't2', label: 'Pesan 50 Pcs', price: 100000 },
    { id: 't3', label: 'Pesan 100 Pcs', price: 85000 },
    { id: 't4', label: 'Pesan > 100 Pcs', price: 80000 },
  ],
  addons: [
    { id: 'a1', label: 'Model Tunik (Panjang)', price: 10000 },
    { id: 'a2', label: 'Ban Karet (Lengan/Bawah)', price: 5000 },
  ]
};

export const INITIAL_PORTFOLIOS: PortfolioItem[] = [
  {
    id: 'p1',
    title: 'E-Commerce Fashion',
    description: 'Platform toko online modern dengan sistem pembayaran terintegrasi.',
    link: 'https://example.com',
    category: 'website',
    imageUrl: 'https://picsum.photos/seed/web1/600/400'
  },
  {
    id: 'p2',
    title: 'Sistem Manajemen Klinik',
    description: 'Aplikasi dashboard untuk pengelolaan data pasien dan jadwal dokter.',
    link: 'https://example.com',
    category: 'aplikasi',
    imageUrl: 'https://picsum.photos/seed/app1/600/400'
  },
  {
    id: 'p3',
    title: 'Ceria Alwafa - Game Edukasi',
    description: 'Multimedia interaktif untuk pembelajaran anak usia dini yang menyenangkan.',
    link: 'https://bisabikin.id/ceria-alwafa/',
    category: 'multimedia',
    imageUrl: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&q=80&w=600'
  },
  {
    id: 'k1',
    title: 'Kaos Gathering Perusahaan',
    description: 'Bahan Cotton Combed 24S dengan sablon plastisol tahan lama.',
    link: '#',
    category: 'kaos',
    imageUrl: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&q=80&w=600'
  },
  {
    id: 'k2',
    title: 'Seragam Komunitas',
    description: 'Warna Navy Blue, Combed 20S tebal dan nyaman.',
    link: '#',
    category: 'kaos',
    imageUrl: 'https://images.unsplash.com/photo-1503341455253-b2e72333dbdb?auto=format&fit=crop&q=80&w=600'
  }
];

export const INITIAL_SECTIONS: LandingSection[] = [
  { 
    id: 'hero', 
    type: 'hero', 
    title: 'Wujudkan Ide Digital Anda Bersama BisaBikin.id', 
    subtitle: 'Platform terintegrasi untuk pembuatan Website, Software dan generator AI tercanggih.', 
    isVisible: true 
  },
  { 
    id: 'about', 
    type: 'about', 
    title: 'Tentang Bisabikin.id', 
    isVisible: true 
  },
  { 
    id: 'features', 
    type: 'features', 
    title: 'Layanan Unggulan Kami', 
    subtitle: 'Dari pengembangan sistem hingga otomasi kecerdasan buatan.', 
    isVisible: true 
  },
  {
    id: 'aida',
    type: 'aida',
    title: 'Ubah Mimpi Menjadi Realitas Digital',
    isVisible: true
  },
  { id: 'stats', type: 'stats', title: 'Dampak Kami', isVisible: false },
];

export const APP_SETTINGS: AppSettings = {
  brandName: 'bisabikin.id',
  primaryColor: '#3b82f6',
  secondaryColor: '#a855f7',
  contactWhatsapp: '628123456789',
  contactEmail: 'rhyzantnue@gmail.com'
};
